var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadWithHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 54,
    viewBox: "0 0 50 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7996 20.3715C48.8451 9.53157 39.7738 0.764803 28.7927 0.0539848C17.5135 -0.715783 7.42808 6.77553 3.96628 20.6676L0.209216 31.6224C-0.246727 32.9776 1.1211 33.4294 2.03299 33.4294L5.63729 33.611C6.05525 33.7887 6.35331 34.2035 6.35331 34.677V41.4594C6.35331 43.4141 7.96474 45.0137 9.93425 45.0137L15.3051 45.9172C15.9616 45.9172 16.4986 46.4502 16.4986 47.1018V51.2488C16.4986 53.2035 18.11 53.9593 20.0795 53.9593H33.4929C36.0411 53.9593 40.3705 54.3544 40.3705 51.2833V48.9681V45.7838C40.3705 42.9406 41.4445 40.2156 43.3544 38.3203C48.0688 33.581 50.4561 27.0651 49.7996 20.3715Z",
    fill: "#EA7054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0778 22.0282C14.5396 27.4931 20.6497 33.0285 25.2372 36.4429C25.6869 36.7669 25.987 36.9119 26.5025 36.5381C32.0772 32.7039 37.632 27.1941 37.7866 22.555C38.3514 14.5789 27.8141 12.7441 25.9491 19.6579C24.5779 13.6657 14.0569 13.4684 14.0778 22.0282Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadWithHeart);
export default __webpack_public_path__ + "static/media/head-with-heart.a97cc1159527f8a2c554029a7a82df20.svg";
export { ForwardRef as ReactComponent };